import {
  HttpClient,
  HttpBackend,
  HttpErrorResponse,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { throwError, Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ReportConfigurationsService {
  constructor(
    private http: HttpClient,
    private httpClient: HttpClient,

    handler: HttpBackend
  ) {
    this.httpClient = new HttpClient(handler);
    this.token = localStorage.getItem("currentClient");
  }

  token: string;

  private API = "/api/report/setting/";
  // private API_REPORTS = '/api/report/setting/';

  handleError(error: HttpErrorResponse) {
    return throwError(error);
  }

  getSettings(): Observable<any> {
    return this.http
      .get(this.API + "getAllReportSetting")
      .pipe(catchError(this.handleError));
  }
  getAllReportContent(): Observable<any> {
    return this.http
      .get(this.API + "getAllReportContent")
      .pipe(catchError(this.handleError));
  }

  saveSettings(payload): Observable<any> {
    return this.http
      .post(this.API + "saveReportSetting", payload)

      .pipe(catchError(this.handleError));
  }

  saveContent(payload): Observable<any> {
    return this.http
      .post(this.API + "saveReportContent", payload)

      .pipe(catchError(this.handleError));
  }

  saveReports(payload): Observable<any> {
    return this.http
      .post(this.API + "saveReports", payload)

      .pipe(catchError(this.handleError));
  }

  getReportByContentId(payload): Observable<any> {
    return this.http
      .get(this.API + "getAllReportsByReportContent/" + payload.id)

      .pipe(catchError(this.handleError));
  }
  getReportByLevel(payload): Observable<any> {
    return this.http
      .get(this.API + "getReportSettingByLevel/" + payload)

      .pipe(catchError(this.handleError));
  }

  updateSettings(payload): Observable<any> {
    return this.http
      .put(this.API + "saveReportContent", payload)

      .pipe(catchError(this.handleError));
  }

  updateContent(payload): Observable<any> {
    return this.http
      .put(this.API + "saveReportContent", payload)

      .pipe(catchError(this.handleError));
  }

  deleteSettings(payload): Observable<any> {
    return this.http
      .delete(this.API + "report-settings" + "/" + payload)

      .pipe(catchError(this.handleError));
  }

  deleteContent(payload): Observable<any> {
    return this.http
      .delete(this.API + "report-content" + "/" + payload)

      .pipe(catchError(this.handleError));
  }

  deleteReports(payload): Observable<any> {
    return this.http
      .delete(this.API + "reports" + "/" + payload)

      .pipe(catchError(this.handleError));
  }
}
